export default Object.freeze({
  FILE_LIST: '/files/',
  FILE_DETAIL: '/files/detail/',
  FILE_GROUP_DETAIL: '/files/groups/',
  UPLOAD: '/upload/',
  WORKFLOW_RUNS: '/workflow-runs/',
  SETTINGS: '/settings/?tab=general-notification-management',
});
